import { Reducer } from 'redux'
import {
  NotificationActions,
  NotificationActionsTypes,
  NotificationState,
} from './NotificationTypes'

const initialState: NotificationState = {
  Notifications: {},
}

export const NotificationReducer: Reducer<NotificationState> = (
  state = initialState,
  action: NotificationActions
) => {
  switch (action.type) {
    case NotificationActionsTypes.ADD_NOTIFICATION: {
      const notification = action.notification

      if (notification.progress > 100) {
        notification.progress = 100
      }

      // if (notification.shallUpdateUI) {
      //   const currentProgress = state.Notifications[notification.id]?.progress

      //   // if (currentProgress === null || currentProgress === -1) {
      //   //   notification.progress = 100
      //   //   // notification.description = ''
      //   // }
      // }

      notification.description =
        notification.description ?? state.Notifications[action.key]?.description

      if (
        notification.description?.indexOf('completed') > -1 ||
        notification.description?.indexOf('done') > -1
      ) {
        notification.progress = 100
      }

      const newNotifications = {
        ...state.Notifications,
        [action.key]: notification,
      }

      return {
        Notifications: newNotifications,
      }
    }
    case NotificationActionsTypes.CLEAR_NOTIFICATION: {
      return initialState
    }
    default:
      return state
  }
}
